import React from 'react'
import styled from 'styled-components'
import PPMori from "../assets/fonts/PPMori-Regular.otf";

export const PrivacyPolicy = () => {
    const howWeUse = [
        "Respond to inquiries",
        "Share research and updates",
        "Provide account access and onboarding",
        "Communicate promotional or platform-related information"
    ]
    const howWeCollect = [
        "Contact forms",
        "Email correspondence (e.g., hello@cosmetic-iq.com)",
        "Newsletter sign-ups",
        "User account registration and platform usage"
    ]
const whatWeCollect = [
    "Name, email address, password",
    "Job title and company name",
    "Account credentials (for registered users)",
    "Billing details: Credit card number, billing address (processed via a secure third-party provider)",
    "Usage data: Features accessed, session length, crash reports",
    "Device information: IP address, browser type, operating system, device identifiers",
    "We may use cookies or similar technologies for analytics and session tracking",
    "Support requests or feedback: Any communication you send us"
]
  return (
    <Container>
        <Main>
            <Inner>
                <Inner1 >
            <DateTxt>Effective Date <span style={{color:'#202327'}}>May 13, 2025</span></DateTxt>
            <DateTxt>Last Updated <span style={{color:'#202327'}}>May 13, 2025</span></DateTxt>
            </Inner1>
            <Inner1>
            <WelcomeTxt>
            CosmeticIQ ("CIQ") is operated by SKINSKOOL Inc., based in Ontario, Canada. This Privacy Policy explains how we collect, use, and protect your personal information when you interact with our Landing Page at <EmailLink href='https://cosmetic-iq.com' target='_blank'>https://cosmetic-iq.com</EmailLink> and our B2B dashboard at <EmailLink target='_blank' href='https://app.cosmetic-iq.com'>https://app.cosmetic-iq.com</EmailLink>.
            </WelcomeTxt>
            <WelcomeTxt>
            By registering for and/or using CIQ, you agree to these Terms.
            </WelcomeTxt>
            </Inner1>
          <Inner1>
            <QTxt>
                1. What We Collect
            </QTxt>

            <WelcomeTxt>
            We may collect the following business-related information:
            </WelcomeTxt>
            <div style={{marginLeft:'1em',display:'flex',flexDirection:'column',gap:12,}}>
            {whatWeCollect.map((txt, index) => (
            <WelcomeTxtList key={index}>
               {txt}
            </WelcomeTxtList>
            ))}
            </div>
           
          </Inner1>
          <Inner1>
            <QTxt>
                2. How We Collect It
            </QTxt>
            <WelcomeTxt>
            Information is collected through:
            </WelcomeTxt>
            <div style={{marginLeft:'1em',display:'flex',flexDirection:'column',gap:12,}}>
            {howWeCollect.map(txt=>
            <WelcomeTxtList>
               {txt}
            </WelcomeTxtList>
            )}
            </div>
           

            </Inner1>
            <Inner1>
            <QTxt>
                3. How We Use It
            </QTxt>
            <WelcomeTxt>
            We use the data to:
            </WelcomeTxt>
            <div style={{marginLeft:'1em',display:'flex',flexDirection:'column',gap:12,}}>
            {howWeUse.map(txt=>
            <WelcomeTxtList>
               {txt}
            </WelcomeTxtList>
            )}
            </div>
           

            </Inner1>
            <Inner1>
            <QTxt>
                4. Data Sharing
            </QTxt>
            <WelcomeTxt>
            We do not share or sell your personal information to third parties. Certain trusted third-party service providers may assist us with secure payment processing or platform hosting, but they do not have rights to use your personal information beyond the scope of their services to us.
            </WelcomeTxt>
            
           

            </Inner1>
            <Inner1>
            <QTxt>
                5. International Users
            </QTxt>
            <WelcomeTxt>
            We are based in Canada, but CIQ may be accessed globally. By using the platform, you consent to the transfer and storage of your data in Canada.
            </WelcomeTxt>
            
           

            </Inner1>
            <Inner1>
            <QTxt>
                6. Updates
            </QTxt>
            <WelcomeTxt>
            We may update this policy from time to time.
            </WelcomeTxt>
            <WelcomeTxt>
            Questions? Please email us at <EmailLink href='mailto:hello@cosmetic-iq.com'>hello@cosmetic-iq.com</EmailLink>
            </WelcomeTxt>
            
           

            </Inner1>
          

           </Inner>
        </Main>
        
    </Container>
  )
}


const Container = styled.div`
// width: 1,228px;
flex:1;


padding: 30px;
gap: 30px;

border: 0px 1px 0px 0px;
// height:75%;
// flex-grow: 1; 

`
const EmailLink = styled.a`
cursor:pointer;
color: #2F3237;
font-weight: 600;
`
const Inner = styled.div`
width: 600px;
display:flex;
flex-direction:column;
gap: 32px;

`
const Inner1 = styled.div`
gap:16px;display:flex;flex-direction:column;`

const Main = styled.div`
padding-top: 60px;
padding-right: 24px;
padding-bottom: 60px;
padding-left: 24px;

border-radius: 24px;
background: #FFFFFF;
overflow:scroll;
box-shadow: 0px 0px 24px 0px #2F323705;

display:flex;
align-items:center;
flex-direction:column;
justify-content:center;
flex-grow: 1; 

`
const DateTxt= styled.p`
font-size: 14px;
font-weight: 700;
line-height: 16.8px;
letter-spacing: -0.01em;
margin:0;

text-underline-position: from-font;
text-decoration-skip-ink: none;
color: #20232799;
font-family:PPMori;

`
const WelcomeTxt= styled.p`

font-size: 16px;
font-weight: 500;
line-height: 22.4px;
letter-spacing: 0%;
font-family:PPMori;
margin:0;

text-underline-position: from-font;
text-decoration-skip-ink: none;
color: #2F3237;

`

const WelcomeTxtList= styled.p`
 
font-size: 16px;
font-weight: 500;
line-height: 22.4px;
letter-spacing: 0%;
font-family:PPMori;
margin:0;
 list-style: none;
  position: relative;
  padding-left: 1em;
  

text-underline-position: from-font;
text-decoration-skip-ink: none;
color: #2F3237;
 &::before {
    content: '•';
    position: absolute;
    left:0;
    bottom:0;
    top:0;
    // background:Red;
    
    font-size: 1.1em; 
    line-height: 1.2;
  }

`
const QTxt = styled.p`

font-size: 22px;
font-weight: 600;
line-height: 26.4px;
letter-spacing: 0%;
font-family:PPMori;
margin:0;

text-underline-position: from-font;
text-decoration-skip-ink: none;
color: #2F3237;
`

const Title = styled.p`

color: #202327;
font-size: 24px;
font-weight: 600;
line-height: 110.00000000000001%;
letter-spacing: -1%;
margin:0;
font-family:PPMori;
`


const ReachoutText = styled.p`
@font-face {
    src: url(${PPMori}) format('truetype');
   font-family:PPMori;
  }

font-family:PPMori;
font-size: 14px;
font-weight: 700;
line-height: 16.8px;
letter-spacing: -0.01em;
text-align: center;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:background: #2F3237;

`